function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
const colors = {
  green: '#daf0ed',
  red: '#facbcf'
};

function TrashcanColor(props) {
  const {
    color = 'red',
    width = 25,
    height = 25,
    size,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size || width,
    height: size || height,
    viewBox: "0 0 34.016 34.016"
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M21.145 5.463c-.06-2.06-2.4-2.21-4.01-2.22-1.59-.01-4.02.16-4.07 2.21h-2.76a.254.254 0 00-.07.02 4.542 4.542 0 00-4.36 4.44.476.476 0 00.47.47h.86c0 6.74-.06 13.49-.06 20.24a.483.483 0 00.47.47H26.4a.478.478 0 00.48-.47q0-10.005.01-20.01a.477.477 0 00-.05-.22h.84a.487.487 0 00.48-.48c-.005-4.16-3.915-4.44-7.015-4.45zm-4.01-1.38c1.23 0 2.92-.15 3.22 1.38h-6.38c.39-1.47 1.85-1.37 3.16-1.38zm8.79 26.11a11.4 11.4 0 01-1.35-.05h-6.33c-3.29 0-6.67.06-10.16-.04 0-.01.01-.01 0-.02-.06-1.06 0-1.53 0-2.13v-6.37c0-3.73-.05-7.47-.06-11.2q8.97 0 17.94.01a.477.477 0 00-.05.22c.01 5.97 0 11.95 0 17.93a10.107 10.107 0 01.01 1.65zm-.07-20.76q-6.27 0-12.53.01h-5.45c-.29 0-.63.04-.95.03.46-1.75 1.3-2.88 3.38-3.04 3.41-.01 6.56-.07 9.97-.07 1.43 0 3.67-.22 5.01.44a3.314 3.314 0 011.58 1.37 5.681 5.681 0 01.53 1.29c-.34 0-1.23-.03-1.54-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: colors[color],
    d: "M27.4 9.463c-.34 0-1.23-.03-1.54-.03q-6.27 0-12.53.01H7.875c-.29 0-.63.04-.95.03.46-1.75 1.3-2.88 3.38-3.04 3.41-.01 6.56-.07 9.97-.07 1.43 0 3.67-.22 5.01.44a3.314 3.314 0 011.58 1.37 5.681 5.681 0 01.535 1.29zM25.915 10.613a.477.477 0 01.05-.22q-8.97-.015-17.94-.01c.01 3.73.06 7.47.06 11.2v6.37c0 .6-.06 1.07 0 2.13.01.01 0 .01 0 .02 3.49.1 6.87.04 10.16.04h6.33a11.4 11.4 0 001.35.05 10.107 10.107 0 00-.01-1.65c0-5.98.01-11.96 0-17.93zm-12.69 17.06a.48.48 0 01-.96 0v-14.66a.485.485 0 01.97 0q-.015 7.335-.01 14.66zm4.26 0a.48.48 0 01-.96 0v-14.66a.485.485 0 01.97 0q.005 7.335-.01 14.66zm4.26 0a.48.48 0 01-.96 0v-14.66a.485.485 0 01.97 0q0 7.335-.01 14.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M21.755 13.013q0 7.335-.01 14.66a.48.48 0 01-.96 0v-14.66a.485.485 0 01.97 0zM17.5 13.013q0 7.335-.01 14.66a.48.48 0 01-.96 0v-14.66a.485.485 0 01.97 0zM13.235 13.013q-.015 7.335-.01 14.66a.48.48 0 01-.96 0v-14.66a.485.485 0 01.97 0z"
  }));
}

export default TrashcanColor;